import { createContext, ReactNode, useState } from "react";

interface AppContextData {
    navDrawer: boolean;
    toggleNavDrawer: any
}

export const AppContext = createContext<AppContextData>({
    navDrawer: false,
    toggleNavDrawer: () =>{}
})

type AppContextProviderProps = {
    children: ReactNode;
}

export const AppContextProvider = ({children}: AppContextProviderProps) =>{
    const [navDrawer, setNavDrawer] = useState<boolean>(false);

    const toggleNavDrawer = () =>{
        setNavDrawer(prev => !prev)
    } 

    const contextData = {
        navDrawer,
        toggleNavDrawer
    }
    return(
        <AppContext.Provider value={contextData}>
            {children}
        </AppContext.Provider>
    )
}